import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import './styles.css';
import CustomTable from '../../../components/CustomTable';
import { REGISTRADO, ANULADO, IMPORTADO } from '../../../common/types/movimientoEstadoType';

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idMovimientoEstado === IMPORTADO)
            return 'blue';
        if (row.idMovimientoEstado === REGISTRADO)
            return 'green';
        if (row.idMovimientoEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            className={'table-reporte-venta-cliente'}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onVer(row)}
                                />
                            </Tooltip>
                            {/* <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEditar(row)}
                                    disabled={row.idMovimientoEstado !== REGISTRADO || row.flagAutomatico ? true : false}
                                />
                            </Tooltip> */}
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="delete"
                                    size={"small"}
                                    onClick={() => props.onAnular(row)}
                                    disabled={row.idMovimientoEstado !== REGISTRADO || row.flagAutomatico ? true : false}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    loading={props.loadingImprimir}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'SerieDocumento',
                    dataIndex: 'serieDocumento',
                    key: 'serieDocumento',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    sorter: true
                },
                {
                    title: 'Almacen',
                    dataIndex: 'nombreAlmacen',
                    key: 'nombreAlmacen',
                    sorter: true
                },
                {
                    title: 'Concepto',
                    dataIndex: 'nombreConcepto',
                    key: 'nombreConcepto',
                    sorter: true
                },
                {
                    title: 'Claim',
                    dataIndex: 'claim',
                    key: 'claim',
                    sorter: true,
                    className: props.flagclaim,

                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoEntidad',
                    key: 'tipoDocumentoEntidad',
                    sorter: true
                },
                {
                    title: 'Número de Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Entidad',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreMovimientoEstado',
                    key: 'nombreMovimientoEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
